import { useNavigate, NavigateFunction } from "react-router-dom";

export let globalNavigate: NavigateFunction;

export const Navigator = () => {
	globalNavigate = useNavigate();
	return null;
};
